export default __webpack_public_path__ + "static/media/pxgroup05.e0479978.png";